<template>
  <Card :disable-title="true">
    <ErrorState />
  </Card>
</template>

<script>
import Card from "@/components/display/Card";
import ErrorState from "@/components/display/ErrorState";

export default {
  name: "errorState",
  components: {
    Card,
    ErrorState,
  },
};
</script>
